import { createFileRoute, redirect } from '@tanstack/react-router'
import { getLoginAppOrigin } from '@/lib/login-app-url'

/**
 * Links mágicos passam pelo app de login dedicado.
 */
export const Route = createFileRoute('/(auth)/l/$token')({
  beforeLoad: ({ params, location }) => {
    const origin = getLoginAppOrigin()
    if (!origin) {
      throw redirect({ to: '/workspace' })
    }
    const { token } = params as { token: string }
    const qs =
      typeof location.searchStr === 'string' && location.searchStr
        ? location.searchStr
        : ''
    throw redirect({
      href: `${origin}/l/${encodeURIComponent(token)}${qs}`,
    })
  },
})
